module.exports = __webpack_public_path__ + "static/media/Robert Mookola.30fffa27.jpg";